export enum SkillResourceSteps {
  ABOUT_THE_SKILL,
  WORKED_EXAMPLE,
  PRACTICE_PROBLEMS,
  SKILL_CHALLENGE,
  PRE_SKILL_CHALLENGE,
}

/**
 * Deep-linking a skill page straight to one of its timeline menu options, e.g.
 * `/skill/N-CM-1?step=practice-problems`.
 *
 * A query param rather than router state so the link survives a reload and is readable in the URL bar.
 * The slug map lives next to the enum so the two ends of the link — whoever builds it and
 * StudentSingleSkill, which reads it — cannot drift apart. PRE_SKILL_CHALLENGE is deliberately absent:
 * nothing renders it, so it is not a place a link can land.
 */
export const SKILL_RESOURCE_STEP_PARAM = 'step';

export const skillResourceStepBySlug = {
  'about-the-skill': SkillResourceSteps.ABOUT_THE_SKILL,
  'worked-example': SkillResourceSteps.WORKED_EXAMPLE,
  'practice-problems': SkillResourceSteps.PRACTICE_PROBLEMS,
  'skill-challenge': SkillResourceSteps.SKILL_CHALLENGE,
} as const;

export type SkillResourceStepSlug = keyof typeof skillResourceStepBySlug;

// The step a `?step=` value names, or null when the param is missing or not one of the slugs above — a
// hand-edited or stale URL must not leave the page with no step at all.
export const parseSkillResourceStepSlug = (slug: string | null): SkillResourceSteps | null =>
  slug && slug in skillResourceStepBySlug ? skillResourceStepBySlug[slug as SkillResourceStepSlug] : null;
